import { CheckInviteResponse } from '@quadminds/client-apis/users';
import { ApiStandardResponse } from '@quadminds/shared/commons';
import { useQuery } from 'react-query';
import { usersApi } from '../services/api';

export const useCheckInvite = (params: { inviteId: string }) => {
    const uuid = params.inviteId;
    return useQuery<ApiStandardResponse<CheckInviteResponse[]>>(
        ['check-invite', uuid],
        () => usersApi.checkInvite({ uuid }),
        {
            refetchOnWindowFocus: false,
        },
    );
};
